export class DriverRankingMetricBreakdownEntity {
  acceptanceRate?: number | null
  shiftAdherence?: number | null
  effectiveDays?: number | null
  effectiveDaysCount?: number | null
  expectedDaysCount?: number | null
  totalWorkingHours?: number | null
  totalCompletedOrders?: number | null
  smoothedOrdersPerHour?: number | null
  dailyHoursScore?: number | null
  productivityScore?: number | null
  scoreBeforePenalties?: number | null
  scoreAfterPenalties?: number | null
}
